/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/

import { gql, useMutation } from '@apollo/client';


const GET_REMAINING_TIME_GQL = gql`
  mutation GetRemainingTime {
    getRemainingTime {
        timeRemaining
    }
}
`;


export const getRemainingTime = () => {
  
  //const [remainingTime, {called}] = useMutation(GET_REMAINING_TIME_GQL);
  
  /*return {
    remainingTime: async () => {
      return {remainingTime, called};
    } 
  };*/
  const [remainingTime, { data, loading, error, called }] = useMutation(GET_REMAINING_TIME_GQL,{context:{clientName:"checkout"}});
  return { remainingTime, data, loading, error, called };
};

